/* eslint-disable max-len */
export default {
  en: {
    bca: {
      atm: [
        'Input your ATM Card and BCA PIN',
        'Select another Transaction Menu',
        'Select transfer menu',
        'Select menu to a Virtual Account BCA',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      mbca: [
        'Login to your m-BCA Account',
        'Select m-Transfer menu',
        'Select Virtual Account BCA',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      klikbca: [
        'Login to your m-BCA Account',
        'Select m-Transfer menu',
        'Select Virtual Account BCA',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
    },
    mandiri: {
      atm: [
        'Input your ATM Card and Mandiri PIN',
        'Select a Purchase menu',
        'Select another menu, and select another menu again',
        'Select an E-Commerce menu',
        'Input Bayarind code XXXXX',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      mandirionline: [
        'Login to your Mandiri Online account',
        'Select a Purchase menu',
        'Select a New Payment menu',
        'Select a Multipayment menu',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      mandiriinternet: [
        'Login to your Mandiri Internet account',
        'Select a Purchase menu',
        'Select a Multipayment menu',
        'Select Bayarind and input Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
    },
    bni: {
      atm: [
        'Input your ATM Card and BNI PIN',
        'Select Another menu',
        'Select a Transfer',
        'Select a Virtual Account Billing',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction ',
      ],
      bnimobilebanking: [
        'Login to your BNI Mobile Account',
        'Select a Transfer',
        'Select a Virtual Account Billing',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      bniibankpersonal: [
        'Login to your iBank Personal BNI Account',
        'Select a Transfer',
        'Select a Virtual Account Billing',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      bnismsbanking: [
        'Send a Text to 3346',
        'Type TRF(space)874+ Input your Bayarind Disbursement Virtual Account number (space)top-up nominal',
        'Follow instruction to complete the transaction',
      ],
    },
    bri: {
      briatm: [
        'Insert your BRI card and Pin.',
        'Select Menu Other Transactions - Payment - Others - BRI VA.',
        'Enter your Bayarind Disbursement Virtual Account number.',
        'On the confirmation page, make sure the payment details are correct.',
        'Follow the instructions to complete the transaction.',
        'Save the transaction receipt as proof of payment.',
      ],
      brimobile: [
        'Enter the BRI Mobile Banking menu.',
        'Select Payment and Select Menu BRIVA.',
        'Enter your Bayarind Disbursement Virtual Account number and payment amount according to the order amount, then select OK.',
        'Enter the PIN.',
        'Payment notification will appear.',
      ],
      briinternet: [
        'Login on the BRI internet banking page.',
        'Select the Payment Menu.',
        'Select Menu BRIVA.',
        'Enter your Bayarind Disbursement Virtual Account number.',
        'Enter the BRI Internet Banking Password.',
        'Enter the BRI internet banking mToken.',
        'Payment notification will appear.',
      ],
    },
    permata: {
      atm: [
        'Enter the Permata ATM card & PIN.',
        'Select another Transaction menu.',
        'Select the Payment menu.',
        'Select the Other Payment menu.',
        'Select the Virtual Account menu.',
        'Enter your Bayarind Disbursement Virtual Account Number then Click the CORRECT button.',
        'Confirm the payment details that appear on the screen, select YES.',
        'Select the account used.',
        'Payment is complete.',
      ],
      pertamamobile: [
        'Login to mobile banking owned by Permata Bank.',
        'Then click the Bill Payment Menu and select the Virtual Account Menu.',
        'Then select your invoice and select New Billing List.',
        'Enter the account number with the Virtual Account number as the Billing Number. When finished, please click Confirm.',
        'Enter the Reminder Name then click Continue. When finished, please click Confirm.',
        'Enter the Response Code and click Confirm when finished.',
        'Payment is complete.',
      ],
      permatanet: [
        'Log in to internet banking.',
        'Select the Payment Menu.',
        'Then select the Bill Payment sub menu and click Virtual Account.',
        'Please select your account then select the account number with the Virtual Account number, then click Continue.',
        'Select Continue to proceed to Payment Details.',
        'Wait a moment until get an SMS notification containing the response CODE.',
        'Click continue after entering the response CODE.',
        'Payment is complete.',
      ],
    },
    maybank: {
      atm: [
        'Input your ATM card and Maybank PIN',
        'Select Transfer Menu & select Another Bank',
        'Select Transfer menu to another Bank',
        'Select Maybank & Input Bank Code 022',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input top-up nominal',
        'Follow instruction to complete the transaction',
      ],
      maybank2u: [
        'Login Maybank Personal Internet Banking website (M2U).',
        'In Transfer page',
        'Select a  Maybank Virtual Account.',
        // eslint-disable-next-line
        'Select Source Fund Account, Input your Bayarind Disbursement Virtual Account number and the amount to be paid.',
        'Will show up a confirmation screen, text message a token (TAC).',
        'Transaction Succeed.',
      ],
    },
    danamon: {
      atm: [
        'Input your ATM Card and Danamon PIN',
        'Select a Purchase menu',
        'Select Virtual Account',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input Nominal Top Up',
        'Follow instruction to complete the transaction',
      ],
      internetbanking: [
        'Login to your Danamon Account',
        'Select a Purchase menu',
        'Select Virtual Account',
        'Input your Bayarind  Disbursement Virtual Account number',
        'Input Nominal Top Up',
        'Follow instruction to complete the transaction',
      ],
    },
    atmbersama: {
      atm: [
        'Enter the Permata ATM card & PIN.',
        'Select Other Transactions.',
        'Select Transfer.',
        'Select To Other Bank Account ATM Bersama / Link.',
        'Enter the destination account number Permata Bank Code (013) + 16 Digits Bayarind Disbursement Virtual Account, then press Correct.',
        'Please fill in or leave the transfer reference number blank then press Correct.',
        'The Transfer Confirmation screen appears containing the destination account number and the amount to be paid, if it is appropriate, press Correct.',
        'Payment is complete.',
      ],
    },
  },
  id: {
    bca: {
      atm: [
        'Masukkan kartu ATM dan PIN BCA Anda',
        'Pilih menu Transaksi Lainnya',
        'Pilih menu Transfer',
        'Pilih menu Ke Rek BCA Virtual Account',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      mbca: [
        'Login ke akun m-BCA Anda',
        'Pilih menu m-Transfer',
        'Pilih BCA Virtual Account',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      klikbca: [
        'Login ke akun Klik BCA Anda',
        'Pilih menu Transfer Dana',
        'Pilih Transfer ke BCA Virtual Account',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
    },
    mandiri: {
      atm: [
        'Masukkan kartu ATM dan PIN Mandiri Anda',
        'Pilih menu Bayar/Beli',
        'Pilih menu Lainnya, pilih menu Lainnya kembali',
        'Pilih menu E-Commerce',
        'Masukkan kode bayarind XXXXX',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      mandirionline: [
        'Login ke akun Mandiri Online Anda',
        'Pilih menu Pembayaran',
        'Pilih menu Buat Pembayaran Baru',
        'Pilih menu Multipayment',
        'Pilih Bayarind dan masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      mandiriinternet: [
        'Login ke akun Mandiri Internet Anda',
        'Pilih menu Pembayaran',
        'Pilih menu Multipayment',
        'Pilih Bayarind dan masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
    },
    bni: {
      atm: [
        'Masukkan kartu ATM dan PIN BNI Anda',
        'Pilih Menu Lainnya',
        'Pilih Transfer',
        'Pilih Virtual Account Billing',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      bnimobilebanking: [
        'Login ke akun BNI Mobile Anda',
        'Pilih Transfer',
        'Pilih Virtual Account Billing',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      bniibankpersonal: [
        'Login ke akun iBank Personal BNI Anda',
        'Pilih Transfer',
        'Pilih Virtual Account Billing',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal top-up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      bnismsbanking: [
        'Kirim SMS ke 3346',
        'Ketik TRF(spasi)874+ nomor Bayarind Disbursement Virtual Account Anda (spasi)Nominal Top-Up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
    },
    bri: {
      briatm: [
        'Masukkan kartu BRI dan Pin Anda.',
        'Pilih Menu Transaksi Lainnya – Pembayaran – Lainnya – BRI VA.',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda.',
        'Di halaman konfirmasi, pastikan detail pembayaran sudah sesuai.',
        'Ikuti instruksi untuk menyelesaikan transaksi.',
        'Simpan struk transaksi sebagai bukti pembayaran.',
      ],
      brimobile: [
        'Masuk ke menu Mobile Banking BRI.',
        'Pilih Pembayaran  dan Pilih Menu BRIVA.',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda dan jumlah pembayaran sesuai dengan jumlah pesanan Anda, kemudia pilih Ok.',
        'Masukkan PIN Anda.',
        'Anda akan mendapatkan notifikasi pembayaran',
      ],
      briinternet: [
        'Login pada halaman internet banking BRI.',
        'Pilih Menu Pembayaran.',
        'Pilih Menu BRIVA.',
        'Masukkan nomor Bayarind Disbursement Virtual Account anda.',
        'Masukkan Password Internet Banking BRI.',
        'Masukkan mToken internet banking BRI.',
        'Anda akan mendapatkan notifikasi pembayaran.',
      ],
    },
    permata: {
      atm: [
        'Masukan kartu ATM dan PIN Permata Anda',
        'Pilih menu Transaksi lainnya ',
        'Pilih menu Pembayaran ',
        'Pilih menu Pembayaran Lainnya ',
        'Pilih menu Virtual Account ',
        'Masukkan Nomor Bayarind Disbursement Virtual Account lalu Klik tombol BENAR ',
        'Konfirmasi detail pembayaran yang muncul pada layar, pilih YA',
        'Pilih rekening yang digunakan',
        'Proses transaksi selesai',
      ],
      pertamamobile: [
        'Login mobile banking yang dimiliki Permata Bank',
        'Lalu klik Menu Pembayaran Tagihan dan pilih Menu Virtual Account',
        'Kemudian pilih Tagihan Anda dan pilih Daftar Tagihan Baru',
        'Masukkan nomor rekening dengan nomor Virtual Account sebagai Nomor Tagihan. Apabila selesai silahkan klik Konfirmasi',
        'Masukkan Nama Pengingat setelah itu klik Lanjut. Apabila selesai silahkan klik Konfirmasi',
        'Masukkan Response Code dan klik Konfirmasi apabila telah selesai',
        'Proses transfer telah selesai',
      ],
      permatanet: [
        'Login internet banking kemudian pilih Menu Pembayaran',
        'Lalu pilih sub menu Pembayaran Tagihan dan klik Virtual Account',
        'Silahkan pilih rekening anda lalu pilih nomor rekening dengan nomor Virtual Account, lalu klik Lanjut',
        'Pilih Lanjutkan untuk melanjutkan proses Detail Pembayaran',
        'Tunggu sebentar hingga Anda memperoleh SMS notifikasi yang berisi KODE respon. ',
        'Klik lanjutkan setelah memasukkan KODE respon tersebut',
        'Proses transfer internet banking telah selesai',
      ],
    },
    maybank: {
      atm: [
        'Masukkan kartu ATM dan PIN Maybank Anda',
        'Pilih menu Transfer lalu pilih Bank Lain',
        'Pilih menu Transfer ke Bank Lain',
        'Pilih Maybank atau masukkan kode bank 022',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal transfer',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      maybank2u: [
        'Login ke website Maybank Personal Internet Banking (M2U).',
        'Di halaman Transfer',
        'Pilih Maybank Virtual Account.',
        // eslint-disable-next-line
        'Pilih rekening sumber dana, masukkan nomor Bayarind Disbursement virtual account dan jumlah yang harus dibayar.',
        'Akan muncul layar konfirmasi, masukkan SMS token (TAC).',
        'Transaksi berhasil.',
      ],
    },
    danamon: {
      atm: [
        'Masukkan kartu ATM dan PIN Danamon',
        'Pilih menu pembayaran',
        'Pilih Virtual Account',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal Top Up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
      internetbanking: [
        'Login ke akun Danamon Anda',
        'Pilih menu pembayaran',
        'Pilih Virtual Account',
        'Masukkan nomor Bayarind Disbursement Virtual Account Anda',
        'Masukkan nominal Top Up',
        'Ikuti instruksi untuk menyelesaikan transaksi',
      ],
    },
    atmbersama: {
      atm: [
        'Pilih menu "Transfer antar bank" atau "Transfer online antar bank".',
        'Masukkan kode bank (013) atau pilih bank yang dituju yaitu Permata.',
        'Masukan 16 Digit Nomor Bayarind Disbursement Virtual Account pada kolom rekening tujuan',
        'Masukkan nominal top up.',
        'Konfirmasi rincian akan tampil di layar, cek dan apabila sudah sesuai silahkan lanjutkan',
        'transaksi sampai dengan selesai.',
        'Transaksi Berhasil.',
      ],
    },
  },
};
